import React, { Component } from 'react';
import styles from './NewProject.module.css';
import PropTypes from 'prop-types';
import FileUpload from '../../components/FileUpload';
import { connect } from 'react-redux';
import { createJob } from '../../modules/jobs';
import ImportForm from '../../components/ImportForm';

class NewProject extends Component {
  state = {
    errorMsg: null,
    successMsg: null,
    formData: {},
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  navTo = (id, cat) => {
    const { router } = this.context;
    const url = `/${cat}${id ? `/${id}` : ''}`;
    router.history.push(url);
  };

  uploadFile = async (type, file) => {
    const { createJob } = this.props;
    const { formData } = this.state;
    formData.type = type;
    if (!formData.project) {
      this.setState({ errorMsg: 'Project name is required' });
      return;
    }
    const result = await createJob(formData, file);
    if (result && result.status === 'ok') {
      const successMsg = `Import Job has been created`;
      this.setState({ successMsg });
    } else {
      this.setState({ errorMsg: 'Failed to import the file' });
    }
  };

  setProjectName = (key, value) => {
    const { formData } = this.state;
    formData[key] = value;
    this.setState({ formData });
  };

  render() {
    const { successMsg, errorMsg, formData } = this.state;
    return (
      <div className={styles.content}>
        <div className={styles.header}>New Project</div>
        <div className={styles.notes}>
          To initiate a new project, upload the project spreadsheet and make
          sure you have assigned all reviewers
        </div>
        <ImportForm
          schema={[{ key: 'project', label: 'Project Name', required: true }]}
          formData={formData}
          onChange={this.setProjectName}
        />
        <FileUpload
          type="import-spreadsheet"
          title="Project Spreadsheet "
          filenote="Excel or Google Sheets .xlsx or .csv format only"
          allowType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          navTo={this.navTo}
          onUpload={this.uploadFile}
        />
        {errorMsg && <p className={styles.errorMsg}>{errorMsg}</p>}
        {successMsg && <p className={styles.successMsg}>{successMsg}</p>}
      </div>
    );
  }
}

export default connect(
  null,
  { createJob }
)(NewProject);



// WEBPACK FOOTER //
// ./src/containers/NewProject/index.js